<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <div class="top-action-bar">
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <div class="d-flex align-items-center">
            <h5 class="page-title mb-0">{{ 'galleryProposal.yourProposals' | transloco }}</h5>
            @if (consignmentProposals.length > 0) {
              <span class="count-badge ms-2"
              >{{currentConsignmentProposal}}</span>
            }
          </div>
          <p class="page-subtitle mb-0 mt-1">
            {{ 'galleryProposal.listShowsProposals' | transloco }}
          </p>
        </div>
        @if (authConfig.IsArtist) {
          <button type="button" pButton class="p-button-outlined p-button-sm"
            icon="pi pi-plus" [label]="'galleryProposal.createProposal' | transloco" (click)="onOpenSendProposalDialog()">
          </button>
        }
      </div>
    </div>
    <!-- Skeleton Loader -->
    @if (isLoading) {
      <div class="row my-2">
        @for (placeholder of [1,2,3,4,5,6]; track placeholder) {
          <div class="col-4 mt-3">
            <div class="skeleton-card">
              <div class="skeleton-image"></div>
              <div class="skeleton-details">
                <div class="skeleton-text skeleton-title"></div>
                <div class="skeleton-text skeleton-line"></div>
                <div class="skeleton-text skeleton-line short"></div>
                <div class="skeleton-text skeleton-line"></div>
              </div>
            </div>
          </div>
        }
        <div class="col-12 text-center text-muted small mt-3">
          <i class="pi pi-spin pi-spinner me-2"></i> {{ 'galleryProposal.loadingProposals' | transloco }}
        </div>
      </div>
    }
    <div class="mt-3">
      <div class="table-responsive">
        <p-table #dt [value]="consignmentProposals" dataKey="Id" [rowHover]="true" [paginator]="true"
          [rows]="15" [rowsPerPageOptions]="[5, 10, 25]"
          [globalFilterFields]="['ArtistName', 'ArtistBusinessName', 'GalleryUserName', 'GalleryBusinessName']"
          selectionMode="single" [paginator]="consignmentProposals.length > 15" [reorderableColumns]="true"
          [resizableColumns]="true" styleClass="p-datatable-gridlines p-datatable-striped">
          <!-- Table caption with filters -->
          <ng-template pTemplate="caption">
            <div class="table-header">
              <div class="d-flex justify-content-end">
                <!-- Search box -->
                <div
                  class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                  <button type="button"
                    class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                    <i
                    class="text-muted fa fa-search icon-block icon-block--search-blue is--small"></i>
                  </button>
                  <input type="text"
                    class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                    (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                    [placeholder]="'galleryProposal.searchByArtistOrBusiness' | transloco" />
                  </div>
                  <!-- Filter dropdowns -->
                  @if (authConfig.IsGallery) {
                    <div class="ms-3" style="width: 220px;">
                      <p-dropdown [options]="artists" [(ngModel)]="filters.ArtistId" [filter]="true"
                        [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'"
                        [showClear]="true" appendTo="body"
                        [style]="{'width':'100%','border':'1px solid white','border-radius':'5px'}"
                        [placeholder]="'galleryProposal.filterByArtist' | transloco" (onChange)="onArtistChanged($event)">
                      </p-dropdown>
                    </div>
                  }
                  @if (authConfig.IsArtist) {
                    <div class="ms-3" style="width: 220px;">
                      <p-dropdown [options]="connectedGalleries" [(ngModel)]="filters.GalleryId"
                        (onChange)="onGalleryChanged($event)" [filter]="true" [showClear]="true"
                        [filterBy]="'label'" appendTo="body" [optionLabel]="'label'"
                        [optionValue]="'value'" [placeholder]="'galleryProposal.filterByGallery' | transloco"
                        [style]="{'border':'1px solid #dee2e6','border-radius':'5px'}">
                      </p-dropdown>
                    </div>
                  }
                  <div class="ms-3" style="width: 220px;">
                    <p-dropdown [options]="consignmentProposalStatusItems" [(ngModel)]="filters.Status"
                      (onChange)="onStatusChange($event)" [filter]="true" [showClear]="true"
                      [filterBy]="'label'" appendTo="body" [optionLabel]="'label'"
                      [optionValue]="'value'" [placeholder]="'galleryProposal.filterByStatus' | transloco"
                      [style]="{'border':'1px solid #dee2e6','border-radius':'5px'}">
                    </p-dropdown>
                  </div>
                </div>
              </div>
            </ng-template>

            <!-- Table header -->
            <ng-template pTemplate="header">
              <tr>
                @if (authConfig.IsGallery) {
                  <th [pSortableColumn]="'ArtistBusinessName'" [title]="'galleryProposal.artist' | transloco"
                    style="min-width: 180px;">
                    {{ 'galleryProposal.proposedTo' | transloco }}
                    <p-sortIcon [field]="'ArtistBusinessName'"></p-sortIcon>
                  </th>
                }
                @if (authConfig.IsArtist) {
                  <th [pSortableColumn]="'GalleryBusinessName'" [title]="'galleryProposal.gallery' | transloco"
                    style="min-width: 180px;">
                    {{ 'galleryProposal.proposedTo' | transloco }}
                    <p-sortIcon [field]="'GalleryBusinessName'"></p-sortIcon>
                  </th>
                }
                <th [pSortableColumn]="'ProposedDate'" style="width: 155px;">
                  {{ 'galleryProposal.proposedDate' | transloco }}
                  <p-sortIcon [field]="'ProposedDate'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'NumberOfConsignmentProducts'">
                  {{ 'galleryProposal.artworks' | transloco }}
                  <p-sortIcon [field]="'NumberOfConsignmentProducts'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="authConfig.IsGallery ? 'ArtistComment' : 'GalleryComment'"
                  style="width: 200px;">
                  @if (authConfig.IsGallery) {
                    {{ 'galleryProposal.artistComments' | transloco }}
                  }
                  @if (authConfig.IsArtist) {
                    {{ 'galleryProposal.galleryComments' | transloco }}
                  }
                  <p-sortIcon
                  [field]="authConfig.IsGallery ? 'ArtistComment' : 'GalleryComment'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="authConfig.IsGallery ? 'GalleryComment' : 'ArtistComment'"
                  style="width: 200px;">
                  {{ 'galleryProposal.yourComments' | transloco }}
                  <p-sortIcon
                  [field]="authConfig.IsGallery ? 'GalleryComment' : 'ArtistComment'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'AcceptedDate'" style="width: 130px;">
                  {{ 'galleryProposal.actionDate' | transloco }}
                  <p-sortIcon [field]="'AcceptedDate'"></p-sortIcon>
                </th>
                <th colspan="2">{{ 'galleryProposal.actions' | transloco }}</th>
              </tr>
            </ng-template>

            <!-- Table body -->
            <ng-template pTemplate="body" let-rowData>
              <tr>
                <!-- Artist details for Gallery view -->
                @if (authConfig.IsGallery) {
                  <td>
                    <div class="d-flex align-items-center">
                      <img [src]="rowData.ArtistImgUrl || 'assets/images/No-Image.png'" width="35"
                        height="35" class="rounded-circle cursor-pointer" />
                        <div class="ms-2" style="max-width: 150px;">
                          <div class="text-truncate" [title]="rowData.Title">
                            {{ rowData.Title ? (rowData.Title | slice:0:25) + (rowData.Title.length > 25
                            ? '...' : '') : '' }}
                          </div>
                          <a href="javascript:void(0);" [routerLink]="['/artist', rowData.ArtistId]"
                            [title]="rowData.ArtistBusinessName">
                            {{ rowData.ArtistBusinessName ? (rowData.ArtistBusinessName | slice:0:30) +
                            (rowData.ArtistBusinessName.length > 30 ? '...' : '') : '' }}
                          </a>
                          <div class="text-muted small" [title]="rowData.ArtistName">
                            {{ rowData.ArtistName ? (rowData.ArtistName | slice:0:25) +
                            (rowData.ArtistName.length > 25 ? '...' : '') : '' }}
                          </div>
                        </div>
                      </div>
                    </td>
                  }
                  <!-- Gallery details for Artist view -->
                  @if (authConfig.IsArtist) {
                    <td>
                      <div class="d-flex align-items-center">
                        <img [src]="rowData.GalleryImgUrl || 'assets/images/No-Image.png'" width="35"
                          height="35" class="rounded-circle cursor-pointer" />
                          <div class="ms-2" style="max-width: 150px;">
                            <div class="text-truncate text-uppercase" [title]="rowData.Title">
                              {{ rowData.Title ? (rowData.Title | slice:0:25) + (rowData.Title.length > 25
                              ? '...' : '') : '' }}
                            </div>
                            <a href="javascript:void(0);"
                              [routerLink]="['/artists', 'gallery', rowData.GalleryId, 'gallery-products']"
                              [title]="rowData.GalleryBusinessName">
                              {{ rowData.GalleryBusinessName ? (rowData.GalleryBusinessName | slice:0:30)
                              + (rowData.GalleryBusinessName.length > 30 ? '...' : '') : '' }}
                            </a>
                            <div class="text-muted small" [title]="rowData.GalleryName">
                              {{ rowData.GalleryName ? (rowData.GalleryName | slice:0:25) +
                              (rowData.GalleryName.length > 25 ? '...' : '') : '' }}
                            </div>
                          </div>
                        </div>
                      </td>
                    }
                    <!-- Proposed date -->
                    <td>{{ rowData.ProposedDate | date: 'dd/MM/yyyy HH:mm' }}</td>
                    <!-- Number of artworks -->
                    <td>
                      @if (rowData.NumberOfConsignmentProducts > 0) {
                        <a href="javascript:void(0);" class="fst-italic"
                          (click)="openViewConsignmentProposalProductsDialog(rowData)">
                          {{ 'galleryProposal.viewNArtworks' | transloco: { count: rowData.NumberOfConsignmentProducts } }}
                        </a>
                      }
                    </td>
                    <!-- Comments (Artist/Gallery) -->
                    <td class="wrap-text-truncate">
                      <div class="text-muted fst-italic"
                        [title]="authConfig.IsGallery ? rowData.ArtistComment : rowData.GalleryComment">
                        @if (authConfig.IsGallery) {
                          {{ rowData.ArtistComment ?
                          (rowData.ArtistComment | slice:0:50) + (rowData.ArtistComment.length > 50 ?
                          '...' : '') : '' }}
                        }
                        @if (authConfig.IsArtist) {
                          {{ rowData.GalleryComment ?
                          (rowData.GalleryComment | slice:0:50) + (rowData.GalleryComment.length > 50 ?
                          '...' : '') : '' }}
                        }
                      </div>
                    </td>
                    <!-- Your Comments -->
                    <td class="wrap-text-truncate">
                      <div class="text-muted fst-italic"
                        [title]="authConfig.IsGallery ? rowData.GalleryComment : rowData.ArtistComment">
                        @if (authConfig.IsGallery) {
                          {{ rowData.GalleryComment ?
                          (rowData.GalleryComment | slice:0:50) + (rowData.GalleryComment.length > 50 ?
                          '...' : '') : '' }}
                        }
                        @if (authConfig.IsArtist) {
                          {{ rowData.ArtistComment ?
                          (rowData.ArtistComment | slice:0:50) + (rowData.ArtistComment.length > 50 ?
                          '...' : '') : '' }}
                        }
                      </div>
                    </td>
                    <!-- Interaction details -->
                    <td class="wrap-text">
                      <div class="d-flex flex-column">
                        <ng-container>
                          <!-- Accepted products -->
                          @if (rowData.IsGalleryInteracted && !rowData.IsProposalRejected) {
                            <div class="d-flex align-items-center mt-1"
                              >
                              <i class="fa fa-check-circle text-success me-2"></i>
                              <span>{{ 'galleryProposal.accepted' | transloco }}</span>
                              <span class="ms-1">({{ rowData.NumberOfAcceptedConsignmentProducts }}/{{
                              rowData.NumberOfConsignmentProducts }})</span>
                            </div>
                          }
                          <!-- Rejected products -->
                          @if (rowData.IsGalleryInteracted && rowData.IsProposalRejected) {
                            <div class="d-flex align-items-center mt-1"
                              >
                              <i class="fa fa-times-circle text-danger me-2"></i>
                              <span>{{ 'galleryProposal.rejected' | transloco }}</span>
                              <span class="ms-1">({{ rowData.NumberOfConsignmentProducts -
                                rowData.NumberOfAcceptedConsignmentProducts }}/{{
                              rowData.NumberOfConsignmentProducts }})</span>
                            </div>
                          }
                          <!-- Interaction date -->
                          <div class="text-small-muted small mt-1">{{ rowData.IntereactedDate | date:
                          'dd/MM/yyyy HH:mm' }}</div>
                        </ng-container>
                      </div>
                    </td>
                    <!-- Proposal status -->
                    <td>
                      <div class="d-flex justify-content-between">
                        @if (rowData.IsProposalAccepted && rowData.AcceptedDate) {
                          <span>
                            <i class="fa fa-check-circle text-success me-1"></i> {{ 'galleryProposal.acceptedOn' | transloco: { date: (rowData.AcceptedDate | date: 'yyyy/MM/dd HH:mm') } }}
                          </span>
                        }
                        @if (rowData.IsProposalRejected && rowData.RejectedDate) {
                          <span>
                            <i class="fa fa-times-circle text-danger me-1"></i> {{ 'galleryProposal.declinedOn' | transloco: { date: (rowData.RejectedDate | date: 'yyyy/MM/dd HH:mm') } }}
                          </span>
                        }
                      </div>
                    </td>
                    <!-- Action buttons -->
                    <td>
                      <div class="d-flex align-items-center">
                        <div>
                          <button type="button" pButton icon="fa fa-history" [label]="'galleryProposal.logs' | transloco"
                            (click)="consignmentProposalDialog(rowData)" class="p-button-secondary">
                          </button>
                        </div>
                        @if (authConfig.IsGallery && !rowData.IsGalleryInteracted) {
                          <div class="d-flex ms-2">
                            <p-button type="button" icon="fa fa-check-circle" [label]="'galleryProposal.review' | transloco"
                              class="p-button-sm p-button-outlined p-button-success" [outlined]="true"
                              (click)="showCommentsDialog(rowData, true)">
                            </p-button>
                          </div>
                        }
                      </div>
                    </td>
                  </tr>
                </ng-template>

                <!-- Empty table message -->
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="8">
                      <div class="text-center">{{ 'galleryProposal.noRecordsFound' | transloco }}</div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>


      <p-dialog [header]="'galleryProposal.includedArtworks' | transloco" [(visible)]="consignmentProposalProductsDialogVisible" [modal]="true"
        (onHide)="closeConsignmentProposalProductsDialog()" [style]="{width: '950px'}">
        <div class="container my-2">
          <div class="d-flex flex-column w-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              @if (selectedConsignmentProposal?.IsGalleryInteracted && authConfig.IsArtist) {
                <div>
                  <div class="d-flex">
                    <img [src]="selectedConsignmentProposal?.GalleryImgUrl ? selectedConsignmentProposal?.GalleryImgUrl : 'assets/images/No-Image.png'"
                      width="35" height="35" class="rounded-circle cursor-pointer" />
                      <div class="ms-2">
                        <div class="d-flex flex-column justify-content-start align-items-start">
                          <a class="" href="javascript:void(0);"
                            [routerLink]="['/profile', selectedConsignmentProposal?.GalleryUserName]">
                            {{selectedConsignmentProposal?.GalleryBusinessName }}
                          </a>
                          <div class="text-muted small">{{selectedConsignmentProposal?.GalleryName}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <!-- Proposal Title -->
              @if (selectedConsignmentProposal?.Title) {
                <div class="mb-3 d-flex flex-column">
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      <h2 class="fw-bold mb-1 text-uppercase">{{ selectedConsignmentProposal?.Title }}</h2>
                    </div>
                    @if (selectedConsignmentProposal?.IsGalleryInteracted  && authConfig.IsArtist   && (!ConsignmentProposalProduct.length || !ConsignmentProposalProduct[0]?.ConsignmentProposal?.ConsignmentId)  && isDispatchedButtonVisible) {
                      <div
                        >
                        <button pButton type="button" [label]="'galleryProposal.prepareDispatchDocuments' | transloco"
                          class="p-button-rounded p-button-lg p-button-primary w-100 fw-bold"
                          (click)="PrepareDispatchDocuments()"
                          style="box-shadow: 0 5px 15px rgba(0,123,255,0.4); transition: background-color 0.3s ease;">
                        </button>
                      </div>
                    }
                  </div>
                  @if (selectedConsignmentProposal?.ProposedDate) {
                    <small class="text-muted mb-2 ms-1 "> {{ selectedConsignmentProposal?.ProposedDate | date:
                    'dd/MM/yyyy HH:mm' }} </small>
                  }
                  @if (selectedConsignmentProposal?.Description) {
                    <small class="text-muted ms-1"> - {{ selectedConsignmentProposal?.Description }}</small>
                  }
                </div>
              }

              <!-- Artist sees Gallery Comments -->
              @if (authConfig.IsArtist) {
                <div class="row mb-4">
                  <div class="col-12 mb-3">
                    <label class="fw-semibold form-label fs-5">{{ 'galleryProposal.yourComments' | transloco }}</label>
                    @if (selectedConsignmentProposal) {
                      <div class="text-muted  "
                        [ngClass]="{'empty-comment': !selectedConsignmentProposal.ArtistComment}">
                        {{ selectedConsignmentProposal.ArtistComment || 'No comments provided' }}
                      </div>
                    }
                  </div>
                  @if (selectedConsignmentProposal?.IsGalleryInteracted) {
                    <div class="col-12">
                      <label class="fw-semibold form-label fs-5">{{ 'galleryProposal.galleryComments' | transloco }}</label>
                      <div class=" text-muted "
                        [ngClass]="{'empty-comment': !selectedConsignmentProposal?.GalleryComment}">
                        {{ selectedConsignmentProposal?.GalleryComment || 'No comments provided' }}
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- Gallery sees Artist Comments -->
              @if (authConfig.IsGallery && selectedConsignmentProposal) {
                <div class="row mb-4">
                  <div class="col-12 mb-3">
                    <label class="fw-semibold form-label fs-5">{{ 'galleryProposal.yourComments' | transloco }}</label>
                    <div class="comment-box text-muted border rounded p-3" [ngClass]="{'empty-comment':
                    !selectedConsignmentProposal.GalleryComment}">
                      {{ selectedConsignmentProposal.GalleryComment || 'No comments provided' }}
                    </div>
                  </div>
                  <div class="col-12">
                    <label class="fw-bold form-label fs-5">{{ 'galleryProposal.artistComments' | transloco }}</label>
                    @if (selectedConsignmentProposal) {
                      <div class="comment-box text-muted border rounded p-3"
                        [ngClass]="{'empty-comment': !selectedConsignmentProposal.ArtistComment}">
                        {{ selectedConsignmentProposal.ArtistComment || 'No comments provided' }}
                      </div>
                    }
                  </div>
                </div>
              }

              <!-- Products List -->
              @if (ConsignmentProposalProduct && ConsignmentProposalProduct.length > 0) {
                <div class="row my-2">
                  @for (product of ConsignmentProposalProduct; track product) {
                    <div class="col-6 mt-2 gallery-tile">
                      <div class="position-relative">
                        <div class="custom-product-container border rounded shadow-sm cursor-pointer"
                          (click)="showProductDetail(product.ArtistProductId)">
                          <div class="custom-img-container">
                            <img [src]="product.ResizedImageUrl ? product.ResizedImageUrl : 'assets/images/No-Image.png'"
                              class="custom-img rounded-cube border" [alt]="'galleryProposal.productImage' | transloco" />
                            </div>
                            <div class="d-flex flex-column w-100 ms-2 p-1">
                              <div class="text-uppercase fw-semibold ellipsis">
                                <a href="javascript:void(0);" class="text-dark fw-semibold">
                                  {{ product?.ArtistProduct_Name }}
                                </a>
                              </div>
                              <div class="d-flex flex-column small mt-2">
                                @if (product.ArtistProduct_ArtTypeName) {
                                  <div class="d-flex align-items-center">
                                    <span class="text-uppercase fw-semibold">{{ 'galleryProposal.artType' | transloco }}</span>
                                    <span class="text-small-muted ms-1">{{ product.ArtistProduct_ArtTypeName
                                    }}</span>
                                  </div>
                                }
                                @if (product.ArtistProduct_ArtistRevenue) {
                                  <div class="d-flex align-items-center">
                                    <span class="text-uppercase fw-semibold">{{ 'galleryProposal.price' | transloco }}</span>
                                    <span class="text-small-muted ms-1">
                                      {{ product.ArtistProduct_ArtistRevenue | currency:'USD':'symbol':'1.2-2' }}
                                    </span>
                                  </div>
                                }
                                @if (product.ArtistProduct_CreatedDate) {
                                  <div class="d-flex flex-row justify-content-between"
                                    >
                                    <div class="d-flex align-items-center cursor-pointer">
                                      <span class="fw-semibold text-uppercase">{{ 'galleryProposal.listed' | transloco }}</span>
                                      <span class="ms-1">{{ product.ArtistProduct_CreatedDate | date: 'dd/MM/yyyy'
                                        }}
                                        @if (isToday(product.ArtistProduct_CreatedDate)) {
                                          {{ 'galleryProposal.today' | transloco }}
                                        }
                                        @if (!isToday(product.ArtistProduct_CreatedDate)) {
                                          {{ 'galleryProposal.daysAgo' | transloco: { count: proposedDaysAgo(product.ArtistProduct_CreatedDate) } }}
                                        }
                                      </span>
                                    </div>
                                  </div>
                                }
                              </div>
                              <!-- Declined Image -->
                              @if (selectedConsignmentProposal?.IsGalleryInteracted == true && product.IsAccpted === false) {
                                <div class="position-absolute top-0 end-0 p-1"
                                  >
                                  <img src="assets\images\cross.png" alt="" width="30" height="30"
                                    [alt]="'galleryProposal.declinedImage' | transloco" class="declined-icon">
                                  </div>
                                }
                                <!-- Accepted Image -->
                                @if (selectedConsignmentProposal?.IsGalleryInteracted && product.IsAccpted === true) {
                                  <div class="position-absolute top-0 end-0 p-1"
                                    >
                                    <img src="assets\images\AFP-logo-tik.png" alt="" width="30" height="30"
                                      [alt]="'galleryProposal.acceptedImage' | transloco" class="accepted-icon">
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }

                    <!-- No products found -->
                    @if (ConsignmentProposalProduct.length === 0) {
                      <div class="row my-2">
                        <div class="col-12 text-center text-muted">{{ 'galleryProposal.noProductsFound' | transloco }}</div>
                      </div>
                    }
                  </div>
                </div>
              </p-dialog>

              <p-dialog [header]="'galleryProposal.viewHistory' | transloco" [(visible)]="showProposalHistory" [modal]="true" [style]="{'width': '530px' }">
                <p-table #dt1 [value]="proposalHistory" dataKey="Id" [rowHover]="true"
                  styleClass="p-datatable-gridlines p-datatable-striped border"
                  [globalFilterFields]="['Message','Name', 'Status']" selectionMode="single"
                  [paginator]="proposalHistory.length > 15" [rows]="15" [reorderableColumns]="true" [resizableColumns]="false">
                  <ng-template pTemplate="caption">
                    <div class="table-header">
                      <div class="d-flex justify-content-end">
                        <div
                          class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                          <button type="button"
                            class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                            <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                          </button>
                          <input type="text"
                            class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                            (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
                            [placeholder]="'galleryProposal.searchByName' | transloco" />
                          </div>

                        </div>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
                      <tr>
                        <th [pSortableColumn]="'Action'">{{ 'galleryProposal.action' | transloco }}
                          <p-sortIcon [field]="'Action'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'ActionDate'">{{ 'galleryProposal.actionDate' | transloco }}
                          <p-sortIcon [field]="'ActionDate'"></p-sortIcon>
                        </th>
                        <!-- <th>Actions</th> -->
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
                      <tr>

                        @if (rowData.Action) {
                          <td>
                            {{rowData.Action}}
                          </td>
                        }
                        @if (rowData.ActionDate) {
                          <td>
                            {{ rowData.ActionDate | date: 'HH:mm /dd/MM yyyy' }}
                          </td>
                        }

                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td [attr.colspan]="8">
                          <div class="text-center">{{ 'galleryProposal.noRecordsFound' | transloco }}</div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-dialog>
                <!--  -->
                <p-dialog [header]="'galleryProposal.sendProposal' | transloco" [(visible)]="isSendPurposalDailogVisible" [modal]="true"
                  (onHide)="onCloseSendPurposalDailog()" [style]="{'width':'1300px','borderRadius':'5px','overflow':'hidden'}"
                  [baseZIndex]="10000">
                  <div class="p-3 bg-white border" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #222;">
                    <!-- Proposal Information Section (Full Width) -->
                    <div class="row mb-4">
                      <div class="col-12">
                        <div class="d-flex align-items-center mb-3" style="font-size: 1rem; gap: 0.5rem;">
                          <i class="fa fa-info-circle fs-4"></i>
                          <span>{{ 'galleryProposal.sendProposalInfo' | transloco }}</span>
                        </div>

                        <div class="row g-3">
                          <div class="col-md-9 d-flex flex-column">
                            <div class="mt-2">
                              <label for="galleryDropdown" class="form-label fw-bold fs-6 text-start">
                                {{ 'galleryProposal.gallerySelection' | transloco }} <span class="text-danger">*</span>
                              </label>
                            </div>
                            <p-dropdown inputId="galleryDropdown" [options]="artistConnectedGalleries"
                              [(ngModel)]="consignment.GalleryId"
                              [placeholder]="!artistId ? 'Select the artist first' : 'Select gallery'" [filter]="true"
                              [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'"
                              (onChange)="onGalleryChanged($event)" styleClass="w-100 rounded-3">
                            </p-dropdown>

                            <div class="mt-3">
                              <label for="proposalTitle" class="form-label fw-bold fs-6">
                                {{ 'galleryProposal.proposalTitle' | transloco }} <span class="text-danger">*</span>
                              </label>
                              <input id="proposalTitle" type="text" class="form-control  rounded py-3"
                                [(ngModel)]="consignmentProposalData.Title" [placeholder]="'galleryProposal.enterProposalTitle' | transloco" />
                              </div>
                            </div>

                            <div class="col-md-3">
                              <fieldset class="border rounded-3 shadow-sm p-2 mt-5">
                                <label class="form-label fw-bold fs-6 text-start">{{ 'galleryProposal.includeInProposal' | transloco }}</label>
                                <div class="d-flex flex-column gap-1">
                                  <!-- Public Profile -->
                                  <div class="d-flex align-items-center">
                                    <p-inputSwitch inputId="publicProfile"
                                    [(ngModel)]="consignmentProposalData.IsShowArtistPublicProfile"></p-inputSwitch>
                                    <label for="publicProfile" class="ms-2 mb-0">{{ 'galleryProposal.publicProfile' | transloco }}</label>
                                  </div>

                                  <!-- Available Inventory -->
                                  <div class="d-flex align-items-center">
                                    <p-inputSwitch inputId="availableInventory"
                                    [(ngModel)]="consignmentProposalData.IsIncludeArtistAvailableInventory"></p-inputSwitch>
                                    <label for="availableInventory" class="ms-2 mb-0">{{ 'galleryProposal.availableInventory' | transloco }}</label>
                                  </div>

                                  <!-- Sales History -->
                                  <div class="d-flex align-items-center">
                                    <p-inputSwitch inputId="salesHistory"
                                    [(ngModel)]="consignmentProposalData.IsIncludeArtistSalesHistory"></p-inputSwitch>
                                    <label for="salesHistory" class="ms-2 mb-0">{{ 'galleryProposal.salesHistory' | transloco }}</label>
                                  </div>
                                </div>
                              </fieldset>
                            </div>



                            <div class="col-12">
                              <label for="comments" class="form-label fw-bold fs-6">
                                {{ 'galleryProposal.proposalDescription' | transloco }}
                              </label>
                              <textarea id="comments" pInputTextarea rows="8" name="Description"
                                [(ngModel)]="consignmentProposalData.Description" [placeholder]="'galleryProposal.writeDescription' | transloco"
                              class="form-control shadow-sm rounded-3" style="resize: vertical;"></textarea>
                            </div>
                          </div>


                        </div>
                      </div>

                      <!-- Artworks Section (Split Layout) -->
                      <div class="row g-3 align-items-stretch">
                        <!-- Available Artworks (Left Side) -->
                        <div class="col-lg-9 d-flex flex-column">
                          <div class="available-artworks p-3 bg-white rounded shadow-sm h-100"
                            style="overflow-y: auto; max-height: 800px; border: 1px solid #eee;">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <h6 class="fw-bold text-secondary m-0">
                                <i class="pi pi-images me-2" style="color:#007bff;"></i>
                                {{ 'galleryProposal.availableArtworks' | transloco }}
                                @if (isCurrentInventoryLoaded) {
                                  <span class="text-muted fs-6">
                                    ({{ consignmentProposalProducts.length }})
                                  </span>
                                }
                              </h6>
                            </div>

                            <div class="row g-2">
                              @for (rowData of consignmentProposalProducts; track rowData) {
                                <div class="col-2">
                                  <div class="artwork-card rounded shadow-sm bg-light border cursor-pointer p-1 d-flex flex-column align-items-center transition-scale"
                                    (click)="selectInventory(rowData)" [title]="'Click to select ' + rowData.Name">
                                    <div class="image-wrapper position-relative w-100">
                                      <img [src]="rowData.ResizedImageUrl ? rowData.ResizedImageUrl : 'assets/images/No-Image.png'"
                                        alt="{{rowData.Name}}" class="img-fluid h-100 w-100 object-fit-contain" />
                                        <i class="fa fa-info-circle position-absolute top-0 end-0 m-2 text-dark fs-4"
                                          style="cursor: pointer;"
                                          (click)="showProductDetail(rowData.Id); $event.stopPropagation()"
                                        [title]="'galleryProposal.viewDetails' | transloco"></i>
                                      </div>
                                      <div class="text-center py-1 w-100">
                                        <h6 class="text-truncate text-uppercase fw-semibold mb-1"
                                          style="font-size: 0.9rem;">
                                          {{ rowData.Name }}
                                        </h6>
                                        <!-- <small class="text-muted d-block" style="font-size:0.85rem;">
                                        {{ rowData.ShortDescription }}
                                      </small> -->
                                    </div>
                                  </div>
                                </div>
                              }

                              @if (consignmentProposalProducts.length === 0) {
                                <div class="text-center text-muted py-5 w-100">
                                  <i class="pi pi-image fs-3 mb-2"></i>
                                  <div>{{ 'galleryProposal.noArtworksFound' | transloco }}</div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>

                        <!-- Selected Artworks (Right Side) -->
                        <div class="col-lg-3 d-flex flex-column">
                          <div class="selected-artworks p-3 bg-light rounded shadow-sm h-100 d-flex flex-column"
                            style="border: 1px solid #eee;">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <h6 class="fw-bold text-secondary m-0">
                                <i class="pi pi-shopping-cart me-2" style="color:#007bff;"></i>
                                {{ 'galleryProposal.selectedArtworks' | transloco }}

                                @if (selectedPurposalInventory.length > 0) {
                                  <span
                                    class="badge text-white d-inline-flex align-items-center justify-content-center"
                                    style="background-color: #178d9b; font-weight: 700; width: 30px; height: 30px; border-radius: 50%;">
                                    {{ selectedPurposalInventory.length }}
                                  </span>
                                }

                              </h6>
                            </div>


                            <button pButton type="button" [label]="'galleryProposal.sendProposal' | transloco"
                              class="p-button-rounded p-button-lg p-button-primary mt-2 mb-2 w-100 fw-bold"
                              (click)="openAddCommentsDialog()"
                              [disabled]="!consignment.GalleryId || !isProductSelected || !consignmentProposalData.Title"
                              style="box-shadow: 0 5px 15px rgba(0,123,255,0.4); transition: background-color 0.3s ease;">
                            </button>


                            @if (selectedPurposalInventory.length > 0) {
                              <div class="text-center text-muted small mb-3">
                                {{ 'galleryProposal.theseArtworksIncluded' | transloco }}
                              </div>
                            }

                            <div class="row g-2 flex-grow-1" style="overflow-y: auto;">
                              @for (selected of selectedPurposalInventory; track selected) {
                                <div class="col-6">
                                  <div class="artwork-card rounded shadow-sm bg-white border cursor-pointer p-1 d-flex flex-column align-items-center transition-scale mb-2"
                                    (click)="moveToCurrentInventory(selected); $event.stopPropagation()"
                                    [title]="'galleryProposal.clickToRemove' | transloco: { name: selected.Name }">
                                    <div class="image-wrapper position-relative w-100">
                                      <img [src]="selected.ProductImgUrl || 'assets/images/No-Image.png'"
                                        alt="{{selected.Name}}" class="img-fluid h-100 w-100 object-fit-contain" />
                                        <i class="fa fa-info-circle position-absolute top-0 end-0 m-2 text-dark fs-4"
                                          style="cursor: pointer;"
                                          (click)="showProductDetail(selected.Id); $event.stopPropagation()"
                                        [title]="'galleryProposal.viewDetails' | transloco"></i>
                                      </div>
                                      <div class="text-center py-1 w-100">
                                        <h6 class="text-truncate text-uppercase fw-semibold mb-1"
                                          style="font-size: 0.85rem;">
                                          {{ selected.Name }}
                                        </h6>
                                        <!-- <small class="text-muted d-block" style="font-size:0.8rem;">
                                        {{ selected.ShortDescription }}
                                      </small> -->
                                    </div>
                                  </div>
                                </div>
                              }

                              @if (selectedPurposalInventory.length === 0) {
                                <div class="text-center text-muted py-5 w-100">
                                  <i class="pi pi-info-circle fs-3 mb-2"></i>
                                  <div>{{ 'galleryProposal.noArtworksSelected' | transloco }}</div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </p-dialog>
                  <!--  -->
                  <!-- Emoji-Dialog -->
                  @if (displayEmojiDialog) {
                    <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
                      (emojiClick)="addEmoji($event)">
                    </app-emoji-list>
                  }


                  @if (showProductDialog) {
                    <app-product-details-dialog [(showProductDialog)]="showProductDialog" [productId]="selectdProductId"
                      (onClose)="closeProductDialog()">
                    </app-product-details-dialog>
                  }

                  <p-dialog [header]="'galleryProposal.addArtistComment' | transloco" [(visible)]="showAddCommentsDialog" [modal]="true" [style]="{'width': '660px'}"
                    (onHide)="showAddCommentsDialog = false">
                    <div class="form-group my-3">
                      <div class="panel-container">
                        <div class="panel-body">
                          <!-- Artist Comment Textarea -->
                          <div class="form-group position-relative">
                            <label for="artistComment" class="form-label">{{ 'galleryProposal.yourComment' | transloco }}</label>
                            <textarea id="artistComment" pInputTextarea rows="8" cols="8"
                              [(ngModel)]="consignmentProposalData.ArtistComment" [placeholder]="'galleryProposal.addYourCommentHere' | transloco"
                              class="form-control">
                            </textarea>
                            <!-- Emoji Picker for Artist Comment -->
                            <div class="emoji-icon position-absolute cursor-pointer fs-6"
                              (click)="openEmojiDialog('ArtistComment')"
                              style="top: 75%; right: 0.5rem; transform: translateY(-50%);">
                              😊
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Send Button -->
                    <button pButton type="button" class="p-button-primary p-button-outlined w-100 mt-4" [label]="'galleryProposal.sendProposal' | transloco"
                      (click)="submitProposalWithComment()">
                    </button>
                  </p-dialog>
                  <!-- Emoji Dialog -->
                  @if (displayEmojiDialog) {
                    <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
                      (emojiClick)="addEmoji($event)">
                    </app-emoji-list>
                  }